module.exports = __webpack_public_path__ + "img/cayka-thumbnail.32345447.png";